import * as React from 'react'
import { Editor } from './Editor'

export const Pre: React.SFC<any> = props => <Editor {...props} />
